import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import FileRepositoryLinkService from '../services/FileRepositoryLinkService';
import AddLinkModal from './AddLinkModal';

class AddLinkModalContainer extends Component {
  static propTypes = {
    attachmentId: PropTypes.string 
  };

  render() {
    return (
      <AddLinkModal
        isOpen={FileRepositoryLinkService.isOpen}
        selectedAttachmentId={FileRepositoryLinkService.selectedAttachmentId}
        onCancel={FileRepositoryLinkService.handleClose}
        onSubmit={FileRepositoryLinkService.handleSubmit}
        onReset={FileRepositoryLinkService.form.reset}
        onChange={FileRepositoryLinkService.form.setValue}
        values={FileRepositoryLinkService.form.getValues()}
        errors={FileRepositoryLinkService.form.errors}
        submitting={FileRepositoryLinkService.fetch.fetching}
        isDirty={FileRepositoryLinkService.form.isDirty}
      />
    );
  }
}

export default observer(AddLinkModalContainer);
